import { getContext } from "@src/client/context";
import getWelcomeMessageAlreadyClosed from "./getWelcomeMessageAlreadyClosed";

const getUserWouldBeShownOldWelcomeMessage = () => {
  const context = getContext();
  const currentBrowseCountry = context.getBrowseCountry();
  const geoCountry = context.getGeoCountry();

  const welcomeMessageAlreadyDismissed = getWelcomeMessageAlreadyClosed();

  return geoCountry !== currentBrowseCountry && !welcomeMessageAlreadyDismissed;
};

export default getUserWouldBeShownOldWelcomeMessage;
